import * as d3 from 'd3';

let _style = {};

const tooltip = d3.select('body')
    .append('div')
    .attr('class', 'd3-tooltip')
    .style('position', 'absolute')
    .style('pointer-events', 'none')
    .style('color', '#000')
    .style('padding', '0')
    .style('margin-left', '5px')
    .style('border-radius', '6px')
    .style('font-size', '14px')
    .style('box-shadow', '0 2px 6px rgba(0,0,0,0.25)')
    .style('opacity', 0)
    .style('min-width', '160px')
    .style('overflow', 'hidden');

const showTooltip = (event, html) => {
    tooltip
        .html(html)
        .style('opacity', 1);

    moveTooltip(event);
};

const moveTooltip = event => {
    const tooltipNode = tooltip.node();

    const tooltipWidth = tooltipNode.offsetWidth;
    const tooltipHeight = tooltipNode.offsetHeight;

    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    const viewportLeft = window.scrollX + 5;
    const viewportRight = window.scrollX + viewportWidth - 5;
    const viewportTop = window.scrollY + 5;
    const viewportBottom = window.scrollY + viewportHeight - 5;

    const occupiedRects = [
        document.querySelector('.mdb-sidebar'),
        document.querySelector('#filters')
    ]
        .map(element => {
            if (!element || window.getComputedStyle(element).visibility === 'hidden') return null;

            const rect = element.getBoundingClientRect();
            if (rect.width === 0 || rect.height === 0) return null;

            return {
                left: rect.left + window.scrollX,
                right: rect.right + window.scrollX,
                top: rect.top + window.scrollY,
                bottom: rect.bottom + window.scrollY
            };
        })
        .filter(Boolean);

    let top = event.pageY - 28;
    const maxTop = Math.max(viewportTop, viewportBottom - tooltipHeight);
    top = Math.min(Math.max(top, viewportTop), maxTop);

    const activeRects = occupiedRects.filter(rect =>
        top < rect.bottom && top + tooltipHeight > rect.top
    );

    let leftBoundary = viewportLeft;
    let rightBoundary = viewportRight;

    activeRects.forEach(rect => {
        if (rect.right <= event.pageX) leftBoundary = Math.max(leftBoundary, rect.right + 5);
        if (rect.left >= event.pageX) rightBoundary = Math.min(rightBoundary, rect.left - 5);
    });

    let left = event.pageX + 12;
    if (left + tooltipWidth > rightBoundary) left = event.pageX - tooltipWidth - 12;

    const maxLeft = Math.max(leftBoundary, rightBoundary - tooltipWidth);
    left = Math.min(Math.max(left, leftBoundary), maxLeft);

    tooltip
        .style('left', `${left}px`)
        .style('top', `${top}px`);
};

const hideTooltip = () => {
    tooltip.style('opacity', 0);
};

function buildTooltipHTML({ category, series, value, color, items, multiCols = false }) {

    const isValidText = (v) => typeof v === 'string' && v.trim() !== '' && v !== "0";

    const isValidNumber = (v) => Number.isFinite(v) && v !== 0;
    const tooltipCategory = isValidText(category) ? category : '';

    if (Array.isArray(items)) {

        const tooltipItems = items.filter(i => i && isValidText(i.series) && isValidNumber(i.value))
            .map(i => ({
                series: i.series,
                value: i.value,
                color: isValidText(i.color) ? i.color : '#999'
            }))
            .sort((a, b) => b.value - a.value);

        if (!tooltipItems.length) return null;

        const cols = multiCols ? (tooltipItems.length > 36 ? 4 : tooltipItems.length > 20 ? 3 : tooltipItems.length > 10 ? 2 : 1) : 1;

        return `
            <div style="background: #bdbdbd; color: #fff; padding: 6px 10px; font-weight: bold">
                ${tooltipCategory}
            </div>

            <div style="background: #f6f6f6; display: grid; grid-template-columns: repeat(${cols}, minmax(10px, 1fr)); column-gap: 8px; row-gap: 0; padding: 4px">
                ${tooltipItems.map(i => `
                    <div style="padding: 6px 10px; display: flex; align-items: center; gap: 8px; white-space: nowrap">
                        <span style="width: 10px; height: 10px; background: ${i.color}; border-radius: 2px; flex-shrink: 0"></span>

                        <span style="flex: 1; overflow: hidden; text-overflow: ellipsis">
                            ${i.series}
                        </span>

                        <span style="font-weight: 600; margin-left: 8px; flex-shrink: 0">
                            ${i.value}
                        </span>
                    </div>
                `).join('')}
            </div>
        `;
    }

    if (!isValidText(series) || !isValidNumber(value)) return null;
    const tooltipColor = isValidText(color) ? color : '#999';

    return `
        <div style="background: #bdbdbd; color: #fff; padding: 6px 10px; font-weight: bold">
            ${tooltipCategory}
        </div>

        <div style="background: #f6f6f6; padding: 6px 10px; display: flex; align-items: center; gap: 8px">
            <span style="width: 10px; height: 10px; background: ${tooltipColor}; border-radius: 2px"></span>

            <span style="flex:1">
                ${series}
            </span>

            <span style="font-weight:600">
                ${value}
            </span>
        </div>
    `;
}

function createXLine(svg, height) {
    return svg.append('line')
        .attr('class', 'x-guide-line')
        .attr('y1', 0)
        .attr('y2', height)
        .attr('stroke', 'rgba(58,58,58,0.38)')
        .attr('stroke-width', 1)
        .style('opacity', 0)
        .style('pointer-events', 'none');
}

function moveXLine(line, x) {
    line
        .attr('x1', x)
        .attr('x2', x)
        .style('opacity', 1);
}

function hideXLine(line) {
    line.style('opacity', 0);
}

function createYLine(svg, width) {
    return svg.append('line')
        .attr('class', 'y-guide-line')
        .attr('x1', 0)
        .attr('x2', width)
        .attr('stroke', 'rgba(58,58,58,0.38)')
        .attr('stroke-width', 1)
        .style('opacity', 0)
        .style('pointer-events', 'none');
}

function moveYLine(line, y) {
    line
        .attr('y1', y)
        .attr('y2', y)
        .style('opacity', 1);
}

function hideYLine(line) {
    line.style('opacity', 0);
}

function createXHoverLayer({svg, x, height, keys, width = null, onHover, onOut}) {
    const layer = svg.append('g')
        .attr('class', 'x-hover-layer');

    layer.selectAll('rect')
        .data(keys.map((k, i) => ({ key: k, index: i })))
        .enter()
        .append('rect')
        .attr('x', d => {
            if (width) {
                return x(d.key) + (x.bandwidth() - width) / 2;
            }

            return x(d.key);
        })
        .attr('y', 0)
        .attr('width', d => width || x.bandwidth())
        .attr('height', height)
        .attr('fill', 'transparent')
        .on('mousemove', (event, d) => onHover(event, d))
        .on('mouseout', onOut);

    return layer;
}

function measureText(text, font = '14px sans-serif') {
    const canvas = measureText.canvas || (measureText.canvas = document.createElement('canvas'));
    const context = canvas.getContext('2d');
    context.font = font;

    return context.measureText(text).width;
}

function detectOffLimitWords(text, limit = 15) {
    return text.split(/\s+/).some(word => word.length > limit);
}

function splitLongLabels(words, maxChunkSize = 20) {
    return words.flatMap(word => {
        if (word.length <= maxChunkSize) return [word];

        const chunks = [];
        for (let i = 0; i < word.length; i += maxChunkSize) {
            chunks.push(word.slice(i, i + maxChunkSize));
        }

        return chunks;
    });
}

function truncateLongLabels(text, normalLimit = 45, longWordLimit = 18) {
    if (!text) return '';

    const hasOffLimit = detectOffLimitWords(text, longWordLimit);
    const limit = hasOffLimit ? longWordLimit : normalLimit;

    return text.length > limit ? text.slice(0, limit - 3) + '...' : text;
}

function truncateLabel(text, limit = 45) {
    if (!text || text.length <= limit) return text;

    const words = text.trim().split(/\s+/);
    if (words.length <= 1) return text.slice(0, limit - 3) + '...';

    let result = '';

    for (const word of words) {
        const candidate = result ? `${result} ${word}` : word;

        if (candidate.length > limit) break;
        result = candidate;
    }

    return result === text ? text : result + '...';
}

function wrapText(textSelection, maxWidth, maxLines, charLimit, chartType = 'bar', rotate = 0, truncate = true) {
    if (truncate === false) return;

    const fitTextToWidth = (tspan, value) => {
        let text = value.trim();

        tspan.text(text);
        if (tspan.node().getComputedTextLength() <= maxWidth) return text;

        while (text.length > 0) {
            text = text.slice(0, -1).trim();
            tspan.text(text + '...');

            if (tspan.node().getComputedTextLength() <= maxWidth) {
                return text + '...';
            }
        }

        tspan.text('...');
        return '...';
    };

    textSelection.each(function () {
        const text = d3.select(this);
        const normalizedText = text.text().trim().replace(/\s+/g, ' ');

        const truncateLimit = rotate < 0 ? 25 : 45;
        const safeText = truncateLongLabels(normalizedText, truncateLimit);

        const originalText = chartType === 'bar' ? truncateLabel(safeText, charLimit) : safeText;
        const words = chartType === 'bar' ? splitLongLabels(originalText.split(/\s+/).filter(Boolean)) : originalText.split(/\s+/).filter(Boolean);

        const y = text.attr('y');
        const textX = text.attr('x') || 0;
        const textAnchor = text.style('text-anchor') || 'middle';

        const lineHeight = 1.1;

        text.text(null);

        let currentLine = [];
        let currentLineIndex = 0;

        let tspan = text.append('tspan')
            .attr('x', textX)
            .attr('y', y)
            .attr('dy', '0.71em')
            .attr('text-anchor', textAnchor);

        for (let i = 0; i < words.length; i++) {

            const word = words[i];
            const testLine = [...currentLine, word];
            tspan.text(testLine.join(' '));

            const exceedsWidth =
                tspan.node().getComputedTextLength() > maxWidth;

            if (!exceedsWidth) {
                currentLine = testLine;
                continue;
            }

            if (currentLine.length === 0) {
                const forced = fitTextToWidth(tspan, word);
                currentLine = [forced];
                break;
            }

            tspan.text(currentLine.join(' '));
            const isLastAllowedLine = currentLineIndex + 1 >= maxLines;

            if (isLastAllowedLine) {
                const remainingText = [...currentLine, ...words.slice(i)].join(' ');
                fitTextToWidth(tspan, remainingText);
                break;
            }

            currentLineIndex++;
            currentLine = [word];

            tspan = text.append('tspan')
                .attr('x', textX)
                .attr('y', y)
                .attr('dy', `${0.71 + currentLineIndex * lineHeight}em`)
                .attr('text-anchor', textAnchor)
                .text(word);

            if (tspan.node().getComputedTextLength() > maxWidth) {
                fitTextToWidth(tspan, word);
                break;
            }
        }

        text.attr('data-lines', Math.min(currentLineIndex + 1, maxLines));
    });
}

function detectLabelOverlap(labels, bandwidth, fontSize = 14) {
    const avgWidth = labels.reduce((sum, label) => {
        return sum + measureText(label, `${fontSize}px sans-serif`);
    }, 0) / labels.length;

    return avgWidth > bandwidth * 1.15;
}

function applyXAxisLabels({xAxis, labels, width, baseMargin, svg, margin, height, bandwidth, chartType = 'bar'}) {
    const xTicks = xAxis.selectAll('.tick text');
    const fontSize = 14;
    let rotate = 0;

    const truncate = labels.length >= 3;

    xTicks.each(function () {
        const text = d3.select(this);
        const raw = truncate ? truncateLabel(truncateLongLabels(text.text(), 45), width < 700 ? 55 : 75) : text.text();

        text.selectAll('tspan').remove();

        text
            .text(raw)
            .attr('transform', null)
            .attr('dx', null)
            .attr('dy', '0.71em')
            .style('text-anchor', 'middle')
            .style('font-size', `${fontSize}px`);
    });

    const hasOverlap = detectLabelOverlap(labels, (chartType === 'bar' ? bandwidth : bandwidth - 15), fontSize);

    const ratios = labels.map(label => measureText(label, `${fontSize}px sans-serif`) / bandwidth);
    const largeLabels = ratios.filter(r => r >= 2.6).length;

    const avgRatio = ratios.reduce((a, b) => a + b, 0) / ratios.length;

    if (hasOverlap) {
        if (chartType === 'bar') {

            rotate = largeLabels >= 1 ? -50 : -30;

        } else if (chartType === 'line') {
            if (avgRatio >= 0.8) rotate = -30;
            if (avgRatio >= 1.1) rotate = -50;
            if (avgRatio >= 2.1) rotate = -70;
            if (avgRatio >= 3.1) rotate = -85;
        }
    }

    const maxWidthWrap = rotate !== 0 ? bandwidth * 0.9 : bandwidth * 1.44;
    if (!hasOverlap) xTicks.call(texts => wrapText(texts, maxWidthWrap, 5, 85, chartType, rotate, truncate));

    if (hasOverlap) {
        const hasLongLabel = labels.some(label => {
            const normalized = label.trim().replace(/\s+/g, ' ');
            return (normalized.length >= 45 || detectOffLimitWords(normalized, 15));
        });

        const bottomSpace = Math.max(baseMargin - 25, 40);
        const projectedWidth = rotate <= -50 ? bottomSpace * 2.25 : bottomSpace * 3;
        const maxWidth = Math.min(rotate <= -50 ? bandwidth * 2.8 : bandwidth * 2.2, projectedWidth);
        const maxLines = rotate <= -50 ? (hasLongLabel ? 4 : 5) : 7;

        xTicks.each(function () {

            const text = d3.select(this);
            const raw = chartType === 'bar' ? truncateLabel(text.text(), width < 700 ? 65 : 85) : text.text();

            text.selectAll('tspan').remove();
            text.text(null);

            const words = raw.split(/\s+/);

            let line = [];
            let lineNumber = 1;

            const lineHeight = 1.05;

            let tspan = text.append('tspan')
                .attr('x', 0)
                .attr('dy', '0.65em');

            for (let index = 0; index < words.length; index++) {
                const word = words[index];

                line.push(word);
                tspan.text(line.join(' '));

                if (tspan.node().getComputedTextLength() > maxWidth) {

                    line.pop();
                    tspan.text(line.join(' '));
                    lineNumber++;

                    if (lineNumber >= maxLines) {

                        const currentText = line.join(' ').trim();

                        const remainingWords = words.slice(index);
                        const remainingText = remainingWords.join(' ').trim();

                        let truncated = `${currentText} ${remainingText}`.trim();
                        if (!truncated) truncated = raw || '...';

                        while (truncated.length > 0) {
                            tspan.text(truncated + '...');
                            if (tspan.node().getComputedTextLength() <= maxWidth) break;

                            truncated = truncated.slice(0, -1).trim();
                        }

                        if (!truncated) tspan.text('...');
                        break;
                    }

                    line = [word];

                    tspan = text.append('tspan')
                        .attr('x', 0)
                        .attr('dy', `${lineHeight}em`)
                        .text(word);
                }
            }

            let translateX;
            let translateY;

            switch (rotate) {
                case -30:
                    translateX = -7;
                    translateY = 2;
                    break;

                case -50:
                    translateX = -10;
                    translateY = 5;
                    break;

                case -70:
                    translateX = -16;
                    translateY = 6;
                    break;

                case -85:
                    translateX = -20;
                    translateY = 6;
                    break;

                default:
                    translateX = -7;
                    translateY = 2;
                    break;
            }

            text
                .style('text-anchor', 'end')
                .style('font-size', `${fontSize}px`)
                .attr(
                    'transform',
                    `translate(${translateX}, ${translateY}) rotate(${rotate})`
                );

            text.attr('data-lines', lineNumber + 1);
        });
    }

    let maxBottom = 0;

    xAxis.selectAll('.tick text').each(function () {

        try {
            const box = this.getBBox();
            const transform = d3.select(this).attr('transform') || '';

            const match = transform.match(/rotate\((-?\d+)\)/);
            const rotate = match ? parseInt(match[1], 10) : 0;

            let extraSpacing;
            switch (rotate) {
                case -30:
                    extraSpacing = 55;
                    break;

                case -50:
                    extraSpacing = 65;
                    break;

                case -70:
                    extraSpacing = 75;
                    break;

                case -85:
                    extraSpacing = 85;
                    break;

                default:
                    extraSpacing = 12;
                    break;
            }

            if (chartType !== 'bar' && rotate !== 0) extraSpacing = 30;

            const totalHeight = box.height + extraSpacing;
            if (totalHeight > maxBottom) maxBottom = totalHeight;

        } catch (e) {
            console.log(e);
        }
    });

    const finalBottom = Math.max(baseMargin, maxBottom + 20);

    svg.attr(
        'viewBox',
        `0 0 ${width + margin.left + margin.right} ${height + margin.top + finalBottom}`
    );

    return finalBottom;
}

function calculateBottomMargin({xAxis, labels = [], width, element, baseMargin = 50, svgRoot, margin, height, bandwidth, chartType = 'bar'}) {
    const dynamicBottom = applyXAxisLabels({xAxis, labels, width, element, baseMargin, svg: svgRoot, margin, height, bandwidth, chartType});

    let axisHeight = 0;
    xAxis.selectAll('.tick text').each(function () {
        const h = this.getBBox().height;
        if (h > axisHeight) axisHeight = h;
    });

    const finalBottom = Math.max(baseMargin, dynamicBottom || 0, axisHeight + 20);

    const totalWidth = width + margin.left + margin.right;
    const totalHeight = height + margin.top + finalBottom;

    svgRoot.attr(
        'viewBox',
        `0 0 ${totalWidth} ${totalHeight}`
    );

    return finalBottom;
}

function applyYAxisLabels({yAxis, labels, availableHeight, maxWidth = 150}) {
    const fontSize = 14;
    const lineHeight = 1.1;
    const lineHeightPx = fontSize * lineHeight;
    const maxLines = Math.max(1, Math.floor((availableHeight - 6) / lineHeightPx));

    const fitTextToWidth = (tspan, value) => {
        let text = value.trim();

        tspan.text(text);
        if (tspan.node().getComputedTextLength() <= maxWidth) return;

        while (text.length > 0) {
            text = text.slice(0, -1).trim();
            tspan.text(text + '...');

            if (tspan.node().getComputedTextLength() <= maxWidth) return;
        }

        tspan.text('...');
    };

    yAxis.selectAll('.tick text')
        .style('font-size', `${fontSize}px`)
        .style('text-anchor', 'end')
        .each(function (label, index) {
            const text = d3.select(this);
            const rawLabel = String(labels[index] ?? label ?? '').trim().replace(/\s+/g, ' ');
            const safeLabel = truncateLabel(truncateLongLabels(rawLabel, 40), 50);
            const words = splitLongLabels(safeLabel.split(/\s+/).filter(Boolean), 18);

            text.text(null);

            let line = [];
            let lineIndex = 0;

            let tspan = text.append('tspan')
                .attr('x', -10)
                .attr('dy', '0.35em')
                .attr('text-anchor', 'end');

            for (let wordIndex = 0; wordIndex < words.length; wordIndex++) {
                const word = words[wordIndex];
                const candidate = [...line, word];

                tspan.text(candidate.join(' '));

                if (tspan.node().getComputedTextLength() <= maxWidth) {
                    line = candidate;
                    continue;
                }

                if (!line.length) {
                    fitTextToWidth(tspan, word);
                    line = [tspan.text()];
                    continue;
                }

                tspan.text(line.join(' '));

                if (lineIndex + 1 >= maxLines) {
                    const remainingText = [...line, ...words.slice(wordIndex)].join(' ');
                    fitTextToWidth(tspan, remainingText);
                    break;
                }

                lineIndex++;
                line = [word];

                tspan = text.append('tspan')
                    .attr('x', -10)
                    .attr('dy', `${lineHeight}em`)
                    .attr('text-anchor', 'end')
                    .text(word);

                if (tspan.node().getComputedTextLength() > maxWidth) {
                    fitTextToWidth(tspan, word);
                }
            }

            const renderedLines = Math.min(lineIndex + 1, maxLines);
            const firstDy = renderedLines > 1
                ? `${-((renderedLines - 1) * lineHeight) / 2 + 0.35}em`
                : '0.35em';

            text.select('tspan').attr('dy', firstDy);
            text.attr('data-lines', renderedLines);
        });
}

const GraphicUtils = {

    colorMap: {},

    getRandomColor() {
        const limitValue = 200;
        const r = Math.floor(Math.random() * limitValue);
        const g = Math.floor(Math.random() * limitValue);
        const b = Math.floor(Math.random() * limitValue);

        return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
    },

    getStackedColor(label) {
        if (!this.colorMap[label]) {
            this.colorMap[label] = this.getRandomColor();
        }
        return this.colorMap[label];
    },

    styleDefault(element) {
        const id = element.attr('id');
        if (!_style[id]) return;
        _style[id].split(';').forEach(rule => {
            const [k, v] = rule.split(':');
            if (k && v) element.style(k.trim(), v.trim());
        });
    },

    dataNotFound(element) {
        element.selectAll('*').remove();
        element.style('height', null).style('min-height', null).style('display', 'block');
        element.append('div')
            .attr('class', 'alert alert-info p-2 h6 text-center w-100 mt-2')
            .style('width', '100%')
            .text('Nenhum registro encontrado no período informado');
    },

    renderLegend({ container, items, color, toggle, columns = 5 }) {
        const legend = container.append('div')
            .attr('class', 'd3-legend')
            .style('display', 'grid')
            .style('grid-template-columns', `repeat(${columns}, auto)`)
            .style('gap', '8px')
            .style('justify-content', 'center')
            .style('margin-top', '12px');

        const item = legend.selectAll('.legend-item')
            .data(items)
            .enter()
            .append('div')
            .attr('class', 'legend-item')
            .style('display', 'flex')
            .style('align-items', 'center')
            .style('cursor', toggle ? 'pointer' : 'default')
            .on('click', function (_, d) {
                if (toggle) toggle(d, this);
            });

        item.append('span')
            .style('width', '14px')
            .style('height', '14px')
            .style('margin-right', '6px')
            .style('background-color', d => color(d))
            .style('display', 'inline-block');

        item.append('span')
            .style('font-size', '14px')
            .style('color', '#000')
            .text(d => d);
    },

    pieChart(elementId, labels, values, height = 300, setParentHeightToAuto = false, showRatio = false) {
        const container = d3.select('#' + elementId);
        container.selectAll('*').remove();

        if (!labels?.length || !values?.length || values.every(v => Number(v) === 0)) {
            this.dataNotFound(container);
            if (setParentHeightToAuto) container.style('height', 'auto');
            return;
        }

        height = Math.max(375, height);

        const width = container.node().clientWidth || height;
        const radius = Math.min(width, height) / 2;

        const color = d3.scaleOrdinal()
            .domain(labels)
            .range(labels.map(() => this.getRandomColor()));

        const hidden = new Set();
        const duration = 700;

        const pie = d3.pie()
            .sort(null)
            .value((d, i) => hidden.has(labels[i]) ? 0 : d);

        const arc = d3.arc()
            .innerRadius(0)
            .outerRadius(radius);

        const svg = container.append('svg')
            .attr('width', width)
            .attr('height', height)
            .append('g')
            .attr('transform', `translate(${width / 2},${height / 2})`);

        const render = (initial = false) => {
            const pieData = pie(values);

            const paths = svg.selectAll('path')
                .data(pieData, d => d.index);

            paths.exit().remove();

            const pathsEnter = paths.enter()
                .append('path')
                .attr('fill', d => color(labels[d.index]))
                .each(function (d) {
                    this._current = initial ? { startAngle: d.startAngle, endAngle: d.startAngle } : d;
                })
                .on('mouseover', (event, d) => {
                    showTooltip(event, buildTooltipHTML({
                        category: labels[d.index],
                        items: [{
                            series: labels[d.index],
                            value: d.data,
                            color: color(labels[d.index])
                        }]
                    }));
                })
                .on('mousemove', moveTooltip)
                .on('mouseout', hideTooltip);

            pathsEnter
                .merge(paths)
                .transition()
                .duration(duration)
                .attrTween('d', function (d) {
                    const interpolate = d3.interpolate(this._current, d);
                    this._current = interpolate(1);
                    return t => arc(interpolate(t));
                });

            const texts = svg.selectAll('text')
                .data(pieData, d => d.index);

            texts.exit().remove();

            texts.enter()
                .append('text')
                .attr('text-anchor', 'middle')
                .attr('fill', '#fff')
                .style('font-size', '14px')
                .style('opacity', 0)
                .merge(texts)
                .transition()
                .duration(duration)
                .style('opacity', d => (d.endAngle - d.startAngle) > 0.3 ? 1 : 0)
                .attr('transform', d => `translate(${arc.centroid(d)})`)
                .text(d =>
                    showRatio
                        ? `${Math.round(d.data / d3.sum(values) * 100)}%`
                        : d.data
                );
        };

        render(true);

        this.renderLegend({
            container,
            items: labels,
            color: d => color(d),
            toggle: (label, node) => {
                hidden.has(label) ? hidden.delete(label) : hidden.add(label);
                d3.select(node).style('opacity', hidden.has(label) ? 0.4 : 1);
                render();
            }
        });

        return { chart: svg, style: width };
    },

    barChart(elementId, values, labels, rotated = false, keepDefaultStyle = true, valuesMask = null) {
        const element = d3.select('#' + elementId);
        element.selectAll('*').remove();

        if (!labels?.length || !values?.length || values.every(v => Number(v) === 0)) {
            this.dataNotFound(element);
            return;
        }

        if (_style[elementId] === undefined && keepDefaultStyle) {
            _style[elementId] = element.attr('style') || '';
        }
        this.styleDefault(element);

        const data = labels.map((l, i) => ({
            key: l,
            value: Number(values[i]) || 0,
            showValue: valuesMask?.[i] ?? values[i]
        }));

        const margin = { top: 20, right: 40, bottom: 50, left: rotated ? 165 : 50 };
        const width = element.node().clientWidth - margin.left - margin.right;

        const barSize = 35;
        const barGap = rotated ? 20 : 10;

        const calculatedHeight = rotated ? data.length * (barSize + barGap) : 375;
        const height = rotated ? Math.max(375, calculatedHeight) : calculatedHeight;

        const svgRoot = element.append('svg')
            .attr('viewBox', `0 0 ${width + margin.left + margin.right} ${height + margin.top + margin.bottom}`)
            .attr('preserveAspectRatio', 'xMinYMin meet')
            .classed('svg-content-responsive', true);

        const svg = svgRoot.append('g')
            .attr('transform', `translate(${margin.left}, ${margin.top})`);

        const guideLine = createXLine(svg, height);

        if (!rotated) {

            const x = d3.scaleBand()
                .domain(labels)
                .range([0, width])
                .padding(0.3);

            const y = d3.scaleLinear()
                .domain([0, d3.max(data, d => d.value)])
                .nice()
                .range([height, 0]);

            const guideLine = createXLine(svg, height);

            svg.selectAll('rect')
                .data(data)
                .enter()
                .append('rect')
                .attr('x', d => x(d.key) + (x.bandwidth() - barSize) / 2)
                .attr('width', barSize)
                .attr('y', d => y(d.value))
                .attr('height', d => height - y(d.value))
                .attr('fill', '#084E8F')
            createXHoverLayer({
                svg,
                x,
                height,
                keys: labels,
                width: barSize,

                onHover: (event, d) => {
                    moveXLine(guideLine, x(d.key) + x.bandwidth() / 2);

                    const row = data[d.index];
                    showTooltip(event, buildTooltipHTML({
                        category: row.key,
                        items: [{
                            series: 'Total',
                            value: row.value,
                            color: '#084E8F'}]
                    }));
                },

                onOut: () => {
                    hideXLine(guideLine);
                    hideTooltip();
                }
            })
                .on('mousemove', moveTooltip)
                .on('mouseout', () => {
                    hideXLine(guideLine);
                    hideTooltip();
                });

            svg.selectAll('.bar-label')
                .data(data)
                .enter()
                .append('text')
                .attr('class', 'bar-label')
                .attr('x', d => x(d.key) + x.bandwidth() / 2)
                .attr('y', d => y(d.value) - 6)
                .attr('text-anchor', 'middle')
                .attr('font-size', '14px')
                .text(d => d.showValue);

            const xAxis = svg.append('g')
                .attr('transform', `translate(0,${height})`)
                .call(d3.axisBottom(x));

            calculateBottomMargin({xAxis, labels, values, width, element, baseMargin: margin.bottom, svgRoot, margin, height, bandwidth: x.bandwidth(), chartType: 'bar'});

        } else {
            const maxBarHeight = 35;

            const y = d3.scaleBand()
                .domain(labels)
                .range([0, height])
                .padding(0.2);

            const bandwidth = Math.min(y.bandwidth(), maxBarHeight);

            const x = d3.scaleLinear()
                .domain([0, d3.max(data, d => d.value)])
                .nice()
                .range([0, width]);

            const guideLine = createYLine(svg, width);

            svg.selectAll('.bar')
                .data(data)
                .enter()
                .append('rect')
                .attr('class', 'bar')
                .attr('y', d => y(d.key) + (y.bandwidth() - bandwidth) / 2)
                .attr('height', bandwidth)
                .attr('x', 0)
                .attr('width', d => x(d.value))
                .attr('fill', '#084E8F')
                .on('mousemove', (event, d) => {
                    moveYLine(guideLine, y(d.key) + y.bandwidth() / 2);

                    showTooltip(event, buildTooltipHTML({
                        category: d.key,
                        items: [{
                            series: 'Total',
                            value: d.value,
                            color: '#084E8F'
                        }]
                    }));
                })
                .on('mouseout', () => {
                    hideYLine(guideLine);
                    hideTooltip();
                });

            const hoverLayer = svg.append('g')
                .attr('class', 'y-hover-layer');

            hoverLayer.selectAll('rect')
                .data(data)
                .enter()
                .append('rect')
                .attr('y', d => y(d.key) + (y.bandwidth() - bandwidth) / 2)
                .attr('height', bandwidth)
                .attr('x', 0)
                .attr('width', width)
                .attr('fill', 'transparent')
                .on('mousemove', (event, d) => {
                    moveYLine(guideLine, y(d.key) + y.bandwidth() / 2);

                    showTooltip(event, buildTooltipHTML({
                        category: d.key,
                        items: [{
                            series: 'Total',
                            value: d.value,
                            color: '#084E8F'
                        }]
                    }));
                })
                .on('mouseout', () => {
                    hideYLine(guideLine);
                    hideTooltip();
                });

            svg.selectAll('.bar').raise();

            svg.selectAll('.bar-label')
                .data(data)
                .enter()
                .append('text')
                .attr('class', 'bar-label')
                .attr('y', d => y(d.key) + y.bandwidth() / 2)
                .attr('x', d => x(d.value) + 6)
                .attr('dy', '0.35em')
                .attr('text-anchor', 'start')
                .attr('font-size', '14px')
                .text(d => d.showValue);

            const yAxis = svg.append('g')
                .call(d3.axisLeft(y).tickSize(0).tickPadding(10));

            applyYAxisLabels({yAxis, labels, availableHeight: y.step()});
        }

        return svg;
    },

    horizontalBarChart(...args) {
        return this.barChart(...args, true);
    },

    lineChart(elementId, dataColumns, keys, xLabel = "", yLabel = "", setElementHeightAuto = false, rotateLabelsLimit = null) {
        const container = d3.select('#' + elementId);
        container.selectAll('*').remove();

        const allValues = (dataColumns || [])
            .flatMap(col => col.slice(1))
            .map(Number)
            .filter(Number.isFinite);

        if (!allValues.length || allValues.every(v => v === 0)) {
            this.dataNotFound(container);
            return;
        }

        let bottomMargin = 50;
        if (keys.length > 15 && keys.length <= 20) bottomMargin = 20;
        if (keys.length > 20) bottomMargin = 90;

        const margin = { top: 20, right: 20, bottom: bottomMargin, left: 50 + (yLabel ? 25 : 0) };
        const width = container.node().clientWidth - margin.left - margin.right;
        const height = setElementHeightAuto ? 300 : 375;

        const totalWidth = width + margin.left + margin.right;
        const totalHeight = height + margin.top + margin.bottom;

        const svgRoot = container
            .append('svg')
            .attr('width', totalWidth)
            .attr('height', totalHeight)
            .attr('viewBox', `0 0 ${totalWidth} ${totalHeight}`)
            .attr('preserveAspectRatio', 'xMidYMid meet')
            .style('width', '100%')
            .style('max-width', '100%')
            .style('display', 'block')
            .style('overflow', 'visible');

        svgRoot.append('defs')
            .append('clipPath')
            .attr('id', `${elementId}-y-axis-clip`)
            .append('rect')
            .attr('x', -margin.left)
            .attr('y', -15)
            .attr('width', margin.left + 20)
            .attr('height', height + 20);

        const svg = svgRoot
            .append('g')
            .attr('transform', `translate(${margin.left},${margin.top})`);

        const x = d3.scaleBand().domain(keys).range([0, width]).padding(0.1);
        const y = d3.scaleLinear().range([height, 0]);

        const hidden = new Set();

        const color = d3.scaleOrdinal()
            .domain(dataColumns.map(d => d[0]))
            .range(dataColumns.map(() => this.getRandomColor()));

        const yAxis = d3.axisLeft(y).tickFormat(d3.format('d'));
        const yAxisWrapper = svg.append('g').attr('clip-path', `url(#${elementId}-y-axis-clip)`);
        const yAxisGroup = yAxisWrapper.append('g').attr('class', 'y-axis');

        const gridGroup = svg.append('g').attr('class', 'grid-background');

        let initialTickCount = null;

        const calculateTickCount = (yMax) => {
            if (yMax <= 5) return yMax + 1;
            if (yMax <= 10) return Math.min(yMax, 5);
            if (yMax <= 20) return 6;
            return 10;
        };

        const updateYScale = () => {
            const visibleCols = dataColumns.filter(col => !hidden.has(col[0]));
            const values = visibleCols
                .flatMap(col => col.slice(1))
                .map(Number)
                .filter(Number.isFinite);

            if (!values.length) return;

            const yMax = d3.max(values);
            const yMin = d3.min(values);
            const range = yMax - yMin;
            const padding = range * 0.1 || 1;

            y.domain([Math.max(0, yMin - padding), yMax + padding]).nice();

            if (initialTickCount === null) initialTickCount = calculateTickCount(yMax);
            yAxis.ticks(initialTickCount);

            yAxisGroup
                .transition()
                .duration(300)
                .call(yAxis.scale(y));

            gridGroup.selectAll('*').remove();
            y.ticks(initialTickCount).forEach(v => {
                gridGroup.append('line')
                    .attr('x1', 0)
                    .attr('x2', width)
                    .attr('y1', y(v))
                    .attr('y2', y(v))
                    .attr('stroke', 'rgba(224,224,224,0.68)')
                    .attr('stroke-width', 1)
                    .attr('stroke-dasharray', '4 3');
            });
        };

        updateYScale();

        const xAxisGroup = svg.append('g')
            .attr('transform', `translate(0,${height})`)
            .call(d3.axisBottom(x));

        const allLineValues = dataColumns.flatMap(c => c.slice(1));
        const finalBottom = calculateBottomMargin({xAxis: xAxisGroup, labels: keys, values: allLineValues, width, element: container, baseMargin: margin.bottom, svgRoot, margin, height, bandwidth: x.bandwidth(), chartType: 'line'});

        if (xLabel) {
            svg.append('text')
                .attr('class', 'x-axis-label')
                .attr('x', width)
                .attr('y', height + finalBottom - 10)
                .attr('text-anchor', 'end')
                .style('font-size', '14px')
                .style('fill', '#444')
                .text(xLabel);
        }

        if (yLabel) {
            svg.append('text')
                .attr('class', 'y-axis-label')
                .attr('transform', 'rotate(-90)')
                .attr('x', -(height / 2))
                .attr('y', -margin.left + 18)
                .attr('text-anchor', 'middle')
                .style('font-size', '14px')
                .style('fill', '#444')
                .text(yLabel);
        }

        const lineGenerator = d3.line()
            .x((d, i) => x(keys[i]) + x.bandwidth() / 2)
            .y(d => y(d));

        const xLine = createXLine(svg, height);
        createXHoverLayer({
            svg, x, height, keys,
            onHover: (event, d) => {
                moveXLine(xLine, x(d.key) + x.bandwidth() / 2);

                const items = dataColumns
                    .filter(c => !hidden.has(c[0]))
                    .map(c => ({
                        series: c[0],
                        value: Number(c[d.index + 1]),
                        color: color(c[0])
                    }))
                    .filter(i => Number.isFinite(i.value));

                showTooltip(event, buildTooltipHTML({ category: keys[d.index], items }));
            },
            onOut: () => {
                hideXLine(xLine);
                hideTooltip();
            }
        });

        const series = dataColumns.map(col => {
            const values = col.slice(1).map(Number);

            const path = svg.append('path')
                .datum(values)
                .attr('fill', 'none')
                .attr('stroke', color(col[0]))
                .attr('stroke-width', 2)
                .attr('d', lineGenerator);

            const pointsGroup = svg.append('g').attr('class', 'line-points');

            pointsGroup.selectAll('g.point')
                .data(values.map((v, i) => ({ value: v, index: i })))
                .enter()
                .append('g')
                .attr('class', 'point')
                .each(function (d) {
                    const g = d3.select(this);

                    g.append('circle')
                        .attr('cx', x(keys[d.index]) + x.bandwidth() / 2)
                        .attr('cy', y(d.value))
                        .attr('r', 4)
                        .attr('fill', color(col[0]));

                    g.append('text')
                        .attr('x', x(keys[d.index]) + x.bandwidth() / 2)
                        .attr('y', y(d.value) - 8)
                        .attr('text-anchor', 'middle')
                        .style('font-size', '14px')
                        .style('fill', color(col[0]))
                        .text(d.value);
                });

            return { name: col[0], path, pointsGroup };
        });

        this.renderLegend({
            container,
            items: dataColumns.map(d => d[0]),
            color: d => color(d),
            toggle: (name, node) => {
                hidden.has(name) ? hidden.delete(name) : hidden.add(name);
                d3.select(node).style('opacity', hidden.has(name) ? 0.4 : 1);

                series.forEach(s => {
                    s.path.interrupt();
                    s.pointsGroup.interrupt();
                    s.pointsGroup.selectAll('*').interrupt();
                });

                updateYScale();

                series.forEach(s => {
                    const isHidden = hidden.has(s.name);
                    const values = s.path.datum();

                    const previousLineGenerator = d3.line()
                        .x((d, i) => x(keys[i]) + x.bandwidth() / 2)
                        .y(() => height);

                    const updatedLineGenerator = d3.line()
                        .x((d, i) => x(keys[i]) + x.bandwidth() / 2)
                        .y(d => y(d));

                    if (isHidden) {

                        s.path
                            .interrupt()
                            .transition()
                            .duration(300)
                            .attr('d', previousLineGenerator(values))
                            .on('end', function () {
                                d3.select(this).style('opacity', 0);
                            });

                        s.pointsGroup
                            .selectAll('circle')
                            .interrupt()
                            .transition()
                            .duration(300)
                            .attr('cy', height);

                        s.pointsGroup
                            .selectAll('text')
                            .interrupt()
                            .transition()
                            .duration(300)
                            .attr('y', height - 8);

                        s.pointsGroup
                            .transition()
                            .delay(300)
                            .style('opacity', 0);

                    } else {

                        s.path
                            .interrupt()
                            .style('opacity', 1)
                            .transition()
                            .duration(300)
                            .attr('d', updatedLineGenerator(values));

                        s.pointsGroup
                            .style('opacity', 1);

                        s.pointsGroup
                            .selectAll('circle')
                            .interrupt()
                            .transition()
                            .duration(300)
                            .attr('cy', d => y(d.value));

                        s.pointsGroup
                            .selectAll('text')
                            .interrupt()
                            .transition()
                            .duration(300)
                            .attr('y', d => y(d.value) - 8);
                    }
                });
            }
        });

        return svg;
    },

    stackedBarChart(elementId, dataColumns, categories, labelX = "", labelY = "") {
        const container = d3.select('#' + elementId);
        container.selectAll('*').remove();

        if (!dataColumns?.length || !categories?.length) {
            this.dataNotFound(container);
            return;
        }

        const keys = dataColumns.map(d => d[0]);

        const rawData = categories.map((_, i) => {
            const o = {};
            dataColumns.forEach(c => o[c[0]] = Number(c[i + 1]) || 0);
            return o;
        });

        if (rawData.every(row => keys.every(k => !row[k]))) {
            this.dataNotFound(container);
            return;
        }

        const categoriesSorted = categories;
        const dataSorted = rawData;

        const maxBarHeight = 35;
        const barSpacing = 5;
        const marginLeft = labelY ? 190 : 165;
        const marginBottom = labelX ? 80 : 40;

        const width = container.node().clientWidth - marginLeft - 30;
        const calculatedHeight = categoriesSorted.length * (maxBarHeight + barSpacing) + marginBottom;
        const height = Math.max(375, calculatedHeight);

        const svg = container.append('svg')
            .attr('width', width + marginLeft + 20)
            .attr('height', height)
            .append('g')
            .attr('transform', `translate(${marginLeft},20)`);

        const hidden = new Set();

        const chartHeight = height - marginBottom;

        const y = d3.scaleBand()
            .domain(categoriesSorted)
            .range([0, chartHeight])
            .padding(0.2);

        const bandwidth = Math.min(y.bandwidth(), maxBarHeight);

        const x = d3.scaleLinear().range([0, width]);

        const color = d3.scaleOrdinal()
            .domain(keys)
            .range(keys.map(k => this.getStackedColor(k)));

        const layersGroup = svg.append('g');

        const labelsGroup = svg.append('g')
            .attr('class', 'value-labels');

        const guideLine = createYLine(svg, width);

        const hoverLayer = svg.append('g')
            .attr('class', 'y-hover-layer');

        const fadeOutLabels = () => {
            labelsGroup.selectAll('text')
                .transition()
                .duration(200)
                .style('opacity', 0);
        };

        const render = () => {
            fadeOutLabels();

            const visibleKeys = keys.filter(k => !hidden.has(k));
            const stack = d3.stack().keys(visibleKeys)(dataSorted);

            const hoverRects = hoverLayer
                .selectAll('rect')
                .data(dataSorted);

            hoverRects.exit().remove();

            hoverRects.enter()
                .append('rect')
                .merge(hoverRects)
                .attr('x', 0)
                .attr('width', width)
                .attr('y', (_, i) => y(categoriesSorted[i]) + (y.bandwidth() - bandwidth) / 2)
                .attr('height', bandwidth)
                .attr('fill', 'transparent')
                .on('mousemove', (event, row) => {
                    const index = dataSorted.indexOf(row);

                    moveYLine(guideLine, y(categoriesSorted[index]) + y.bandwidth() / 2);

                    const items = keys
                        .filter(k => !hidden.has(k))
                        .map(k => ({
                            series: k,
                            value: row[k],
                            color: color(k)
                        }))
                        .filter(i =>
                            i &&
                            i.series != null &&
                            i.series !== '' &&
                            Number.isFinite(i.value)
                        );

                    showTooltip(event, buildTooltipHTML({
                        category: categoriesSorted[index],
                        items,
                        multiCols: true
                    }));
                })
                .on('mouseout', () => {
                    hideYLine(guideLine);
                    hideTooltip();
                });

            const maxVisible = d3.max(dataSorted, d =>
                visibleKeys.reduce((sum, k) => sum + d[k], 0)
            );

            x.domain([0, maxVisible || 1]).nice();

            const layers = layersGroup.selectAll('.layer').data(stack, d => d.key);
            layers.exit().remove();

            const layersEnter = layers.enter()
                .append('g')
                .attr('class', 'layer')
                .attr('fill', d => color(d.key));

            const mergedLayers = layersEnter.merge(layers);

            const rects = mergedLayers.selectAll('rect')
                .data(d => d.map((item, index) => ({...item, category: categoriesSorted[index]})), d => d.category);

            rects.exit().remove();

            rects.enter()
                .append('rect')
                .attr('y', d => y(categoriesSorted[dataSorted.indexOf(d.data)]) + (y.bandwidth() - bandwidth) / 2)
                .attr('height', bandwidth)
                .attr('x', d => x(d[0]))
                .attr('width', d => Math.max(0, x(d[1]) - x(d[0])))
                .on('mouseover', function (event, d) {
                    const index = dataSorted.indexOf(d.data);

                    moveYLine(guideLine, y(categoriesSorted[index]) + y.bandwidth() / 2);

                    const category = categoriesSorted[index];
                    const items = keys
                        .filter(k => !hidden.has(k))
                        .map(k => ({
                            series: k,
                            value: d.data[k],
                            color: color(k)
                        }))
                        .filter(i => i && i.series != null && i.series !== '' && Number.isFinite(i.value));

                    showTooltip(event, buildTooltipHTML({ category, items, multiCols: true }));
                })
                .on('mousemove', (event, d) => {
                    const index = dataSorted.indexOf(d.data);

                    moveYLine(guideLine, y(categoriesSorted[index]) + y.bandwidth() / 2);
                    moveTooltip(event);
                })
                .on('mouseout', () => {
                    hideYLine(guideLine);
                    hideTooltip();
                })
                .merge(rects)
                .transition()
                .duration(600)
                .attr('y', d => y(categoriesSorted[dataSorted.indexOf(d.data)]) + (y.bandwidth() - bandwidth) / 2)
                .attr('x', d => x(d[0]))
                .attr('width', d => Math.max(0, x(d[1]) - x(d[0])))
                .on('end', () => {
                    renderLabels(stack);

                    layersGroup.raise();
                    labelsGroup.raise();
                });
        };

        const renderLabels = (stack) => {
            labelsGroup.selectAll('text').remove();

            stack.forEach(layer => {
                layer.forEach(d => {
                    const value = d[1] - d[0];
                    if (!value) return;

                    const index = dataSorted.indexOf(d.data);
                    const yPos = y(categoriesSorted[index]) + y.bandwidth() / 2;
                    const barWidth = x(d[1] - d[0]);
                    const xPos = x(d[1]);

                    const minBarWidth = 28;
                    if (barWidth < minBarWidth) return;

                    labelsGroup.append('text')
                        .attr('x', xPos - 8)
                        .attr('y', yPos)
                        .attr('dy', '0.35em')
                        .attr('text-anchor', 'end')
                        .attr('fill', '#fff')
                        .attr('font-size', '14px')
                        .style('opacity', 0)
                        .text(value)
                        .transition()
                        .duration(300)
                        .style('opacity', 1);
                });
            });
        };

        const yAxis = svg.append('g')
            .call(d3.axisLeft(y).tickSize(0).tickPadding(10));

        yAxis.selectAll(".tick text")
            .style("font-size", "14px")
            .call(texts => {
                texts.each(function () {
                    const text = d3.select(this);
                    const rawLabel = text.text().trim().replace(/\s+/g, ' ');
                    const safeLabel = truncateLabel(truncateLongLabels(rawLabel, 35), 45);
                    const words = safeLabel.split(/\s+/).filter(Boolean);
                    text.text(null);

                    const maxWidth = 150;
                    let line = [];

                    let tspan = text.append("tspan")
                        .attr("x", -10)
                        .attr("dy", "0.25em")
                        .attr("text-anchor", "end");

                    words.forEach(word => {
                        line.push(word);
                        tspan.text(line.join(" "));
                        if (tspan.node().getComputedTextLength() > maxWidth) {
                            line.pop();
                            tspan.text(line.join(" "));
                            line = [word];
                            tspan = text.append("tspan")
                                .attr("x", -10)
                                .attr("dy", "1.1em")
                                .attr("text-anchor", "end")
                                .text(word);
                        }
                    });
                });
            });

        if (labelX) {
            svg.append("text")
                .attr("x", width)
                .attr("y", height - 25)
                .attr("text-anchor", "end")
                .style("font-size", "14px")
                .text(labelX);
        }

        if (labelY) {
            svg.append("text")
                .attr("transform", "rotate(-90)")
                .attr("x", -(chartHeight / 2))
                .attr("y", -marginLeft + 30)
                .attr("text-anchor", "middle")
                .style("font-size", "14px")
                .text(labelY);
        }

        this.renderLegend({
            container,
            items: keys,
            color: d => color(d),
            toggle: (key, node) => {
                hidden.has(key) ? hidden.delete(key) : hidden.add(key);
                d3.select(node).style('opacity', hidden.has(key) ? 0.4 : 1);
                render();
            }
        });

        render();
        return svg;
    },

    horizontalStackedBarChart(dataArray, elementId, labelKey) {
        const container = document.getElementById(elementId);

        if (!Array.isArray(dataArray) || dataArray.length === 0 || dataArray.every(item => item.qty === 0)) {
            if (container) {
                container.innerHTML = `
                    <div class="alert alert-info p-2 h6 text-center w-full">
                        Nenhum registro encontrado no período informado.
                    </div>
                `;
            }
            return null;
        }

        const sortedData = [...dataArray].sort((a, b) => b.qty - a.qty);
        const total = sortedData.reduce((sum, item) => sum + item.qty, 0);

        const colorOrder = (() => {
            switch (sortedData.length) {
                case 1: return ['#1f77b4'];
                case 2: return ['#1f77b4', '#66a1e4'];
                case 3: return ['#1f77b4', '#66a1e4', '#383838'];
                default: return ['#1f77b4', '#66a1e4', '#383838', '#c4c4c4'];
            }
        })();

        const widthMap = sortedData.map((item, idx) => ({
            ...item,
            width: total === 0 ? 0 : (item.qty * 100 / total),
            color: colorOrder[idx] || '#c4c4c4'
        }));

        const minWidth = 10;
        let fixedTotal = 0;

        const adjustedMap = widthMap.map(item => {
            if (item.qty > 0 && item.width < minWidth) {
                fixedTotal += minWidth;
                return { ...item, width: minWidth, fixed: true };
            }
            return { ...item, fixed: false };
        });

        const remainingItems = adjustedMap.filter(i => !i.fixed && i.qty > 0);
        const remainingTotal = remainingItems.reduce((sum, i) => sum + i.qty, 0);
        const availableWidth = 100 - fixedTotal;

        const finalMap = adjustedMap.map(item => {
            if (item.fixed || item.qty === 0) return item;
            return {
                ...item,
                width: remainingTotal === 0 ? 0 : (item.qty / remainingTotal) * availableWidth
            };
        });

        container.style.display = "flex";
        container.style.gap = "3.5px";

        container.innerHTML = finalMap.map(item =>
            item.qty > 0 ? `
                <div class="horizontalBars" style="width: ${item.width.toFixed(2)}%; background-color: ${item.color}; min-width: fit-content"
                data-category="${item[labelKey]}" data-series="Total" data-value="${item.qty}" data-color="${item.color}"> ${item[labelKey]}: ${item.qty} </div>`
                : ''
        ).join('');

        container.querySelectorAll('.horizontalBars').forEach(bar => {
            bar.addEventListener('mouseenter', event => {
                showTooltip(event, buildTooltipHTML({
                    category: bar.dataset.category,
                    series: bar.dataset.series,
                    value: bar.dataset.value,
                    color: bar.dataset.color
                }));
            });

            bar.addEventListener('mousemove', moveTooltip);
            bar.addEventListener('mouseleave', hideTooltip);
        });

        return {
            labels: sortedData.map(i => i[labelKey]),
            values: sortedData.map(i => i.qty)
        };
    }

};

export default GraphicUtils;